enum MedicareMembershipCountTypeEnum {
  All = "All",
  Hundred = "100",
  Thousand = "1,000",
  FiveThousand = "5,000",
  TenThousand = "10,000",
}

export { MedicareMembershipCountTypeEnum };
